@let type = store.typeSg();

<!-- 
  Wrapper container for the entire overlay content (mat-calendar not included).
  Provides shared visual styling such as box shadow,
  and serves as a relative positioning context for all inner elements.
  This allows easier alignment and layout control of the overlay components
  as a unified dialog.
-->
<div
  class="atn-ds-date-range-overlay-content__wrapper"
  [class.atn-ds-date-range-overlay-content__wrapper--has-header]="
    type === 'multirange'
  "
>
  <!-- Overlay Header -->
  @if (type === 'multirange') {
    <atn-ds-date-multi-range-header />
  }

  <!-- Overlay Content -->
  <atn-ds-date-range-overlay-content-form />
  <atn-ds-date-range-overlay-content-custom-ranges />
</div>

<!-- 
  Angular Material calendar header component.
  Must remain positioned relative to <mat-calendar>,
  so it is placed outside the wrapper to preserve correct visual alignment.
-->
<mat-calendar-header />
